"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _SearchList = _interopRequireDefault(require("./SearchBox/components/SearchList"));
var _Actions = require("./store/actions/Actions");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/**
 * This provides a generic Search View implementation for the
 * Bento Case Search sidebar.
 *
 * @param {object} props
 * @param {object} props.classes - styles
 * @param {boolean} props.hidden - whether to hide the component
 * @param {object} props.state - redux state
 * @param {function} props.resetUpload - redux action to reset upload data
 * @param {object} props.SearchBox - Generated SearchBox component
 * @param {object} props.UploadModal - Generated UploadModal component
 * @returns {JSX.Element}
 */
var SearchView = function SearchView(props) {
  var classes = props.classes,
    hidden = props.hidden,
    state = props.state,
    resetUpload = props.resetUpload,
    UploadModal = props.UploadModal,
    SearchBox = props.SearchBox;
  var _ref = (0, _react.useState)(false),
    _ref2 = _slicedToArray(_ref, 2),
    showCasesModal = _ref2[0],
    setShowCasesModal = _ref2[1];
  var matchedFiles = state && state.upload ? state.upload : [];
  var eventHandler = function eventHandler(e) {
    e.stopPropagation();
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchContainer,
    onFocus: eventHandler,
    onClick: eventHandler,
    hidden: hidden
  }, matchedFiles.length !== 0 ? /*#__PURE__*/_react.default.createElement(_SearchList.default, {
    classes: {
      divider: classes.customDivider,
      listPadding: classes.customListPadding
    },
    items: ['INPUT SET'],
    id: "localFindCaseUploadSet",
    onDelete: resetUpload
  }) : null, /*#__PURE__*/_react.default.createElement(SearchBox, {
    classes: classes
  }), /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    disableElevation: true,
    onClick: function onClick() {
      return setShowCasesModal(true);
    },
    className: classes.uploadButton,
    id: "local_find_upload_open"
  }, matchedFiles.length !== 0 ? 'View Case Set' : 'Upload Case Set', /*#__PURE__*/_react.default.createElement("span", {
    className: classes.iconSpan
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.uploadIcon,
    src: "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/bento/images/icons/svgs/localfindUplwardArrow.svg",
    alt: "upload icon"
  }))), /*#__PURE__*/_react.default.createElement(UploadModal, {
    open: showCasesModal,
    onCloseModal: function onCloseModal() {
      return setShowCasesModal(false);
    }
  }));
};
var stateProps = function stateProps(state) {
  return {
    state: state.localFind
  };
};
var dispatchProps = function dispatchProps(dispatch) {
  return {
    resetUpload: function resetUpload() {
      return dispatch((0, _Actions.resetUploadData)());
    }
  };
};
var _default = (0, _reactRedux.connect)(stateProps, dispatchProps)(SearchView);
exports.default = _default;